<template>
  <div class="w-100">
    <JobProfileSettingsSkeleton v-if="pageLoading" />

    <div
      v-else
      class="form-wrapper"
    >
      <JobProfileFieldsSection />
      <JobProfileLevelsSection />

      <div class="d-flex align-center ga-4 w-100">
        <DpplAutoSizedButton
          :disabled="!isDirty || componentLoading || !isSaveValid"
          :loading="componentLoading"
          @click="save"
        >
          Update
        </DpplAutoSizedButton>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import DpplAutoSizedButton from '@/components/datapeople/DpplAutoSizedButton.vue';
import JobProfileFieldsSection from '@/components/settings/components/JobProfileFieldsSection.vue';
import JobProfileLevelsSection from '@/components/settings/components/JobProfileLevelsSection.vue';
import JobProfileSettingsSkeleton from '@/components/settings/components/JobProfileSettingsSkeleton.vue';
import { useAppLoading } from '@/stores/app/loading';
import { useJobProfileSettings } from '@/stores/settings/jobProfileSettings';

const jobProfileSettings = useJobProfileSettings();
const { isDirty, isSaveValid } = storeToRefs(jobProfileSettings);
const { load, save } = jobProfileSettings;

const { componentLoading, pageLoading } = storeToRefs(useAppLoading());

onMounted(async () => {
  await load();
});
</script>

<style scoped lang="less">
.form-wrapper {
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  border-radius: 10px;
  background: @bg-default;
  padding: 40px;
}
</style>
